export default function bankAccountFactory(bankAccountNumber = '') {
  return `***${bankAccountNumber.substr(bankAccountNumber.length - 4)}`;
}
